// Same 16-language set, flag icons, and localStorage persistence as
// mambu-sparks-studio's frontend/src/components/TopBar.tsx — see
// ARCHITECTURE_DECISIONS.md for why this mirrors Studio's approach exactly
// (including its "no backend-persisted preference" scope).
// The names and their order are the prototype's `LOCALES`
// (subscription-portal.html): each language by its English name, read through
// `appShell.locales.<code>` so a translated UI can name them in its own
// language (ARCHITECTURE_DECISIONS.md §53), so no name is kept here.
export interface LocaleEntry {
  code: string
  flag: string
}

/** The menu's order and flags; its codes are i18n's SUPPORTED_LANGUAGES
 * (a test keeps the two sets equal). `as const` keeps each code a literal, so
 * `appShell.locales.<code>` type-checks as an i18n key. */
export const LOCALES = [
  { code: 'en', flag: '🇬🇧' },
  { code: 'pt', flag: '🇵🇹' },
  { code: 'es', flag: '🇪🇸' },
  { code: 'ru', flag: '🇷🇺' },
  { code: 'fr', flag: '🇫🇷' },
  { code: 'ka', flag: '🇬🇪' },
  { code: 'zh', flag: '🇨🇳' },
  { code: 'id', flag: '🇮🇩' },
  { code: 'ro', flag: '🇷🇴' },
  { code: 'my', flag: '🇲🇲' },
  { code: 'de', flag: '🇩🇪' },
  { code: 'pt-BR', flag: '🇧🇷' },
  { code: 'vi', flag: '🇻🇳' },
  { code: 'it', flag: '🇮🇹' },
  { code: 'th', flag: '🇹🇭' },
  { code: 'no', flag: '🇳🇴' },
] as const satisfies readonly LocaleEntry[]
